"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BasketsManager = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_redux_1 = require("react-redux");
var react_1 = require("react");
var get_client_thunk_1 = require("../../../../reducers/slices/client/thunks/get_client_thunk");
var react_2 = require("@nextui-org/react");
var react_3 = require("@iconify/react");
var main_1 = require("../../../../reducers/slices/main");
var basket_management_1 = __importDefault(require("../configurations/basket_management/basket_management"));
var BasketsManager = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var client = (0, react_redux_1.useSelector)(function (state) { return state.clientState; }).client;
    (0, react_1.useEffect)(function () {
        if (!(client === null || client === void 0 ? void 0 : client._id)) {
            dispatch((0, get_client_thunk_1.get_client_thunk)());
        }
    }, [client]);
    var handleOpenBasketManagement = function () {
        dispatch((0, main_1.setContentModal)({
            title: "Basket Management Settings",
            content: (0, jsx_runtime_1.jsx)(basket_management_1.default, {}),
        }));
    };
    return ((0, jsx_runtime_1.jsx)(react_2.Card, __assign({ className: "bg-white", radius: "sm", shadow: "none" }, { children: (0, jsx_runtime_1.jsx)(react_2.CardBody, __assign({ className: "p-4" }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "fle flex-col gap-4" }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "flex flex-col lg:flex-row" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex-1 flex flex-col gap-4" }, { children: [(0, jsx_runtime_1.jsx)("label", { children: "Basket Management" }), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex gap-4" }, { children: [(0, jsx_runtime_1.jsx)(react_2.Button, __assign({ className: "w-14 h-14", isIconOnly: true, onPress: handleOpenBasketManagement, radius: "sm", size: "sm", variant: "bordered" }, { children: (0, jsx_runtime_1.jsx)(react_3.Icon, { icon: "solar:settings-linear", width: "24", height: "24" }) })), (0, jsx_runtime_1.jsx)("label", { children: "Abandonment Timeframe" })] }))] })) })) })) })) })));
};
exports.BasketsManager = BasketsManager;
